import {
  createFileRoute,
  notFound,
  stripSearchParams,
} from '@tanstack/react-router';
import { z } from 'zod';
import AdminView from '../../../pages/adminView/AdminView';
import { VIEW_ADMIN_PAGE } from '../../../utils/permissions';

const searchDefaults = {
  sampleSetId: undefined,
  sampleId: undefined,
  showUserOwnedOnly: false,
  search: '',
} as const;

const searchSchema = z.object({
  sampleSetId: z.string().optional().catch(searchDefaults.sampleSetId),
  sampleId: z.string().optional().catch(searchDefaults.sampleId),
  showUserOwnedOnly: z.boolean().catch(searchDefaults.showUserOwnedOnly),
  search: z.string().catch(searchDefaults.search),
});

export type AdminViewSearch = z.infer<typeof searchSchema>;

export const Route = createFileRoute('/_authenticated/_navbar/admin-view')({
  validateSearch: searchSchema,
  search: {
    middlewares: [stripSearchParams(searchDefaults)],
  },
  beforeLoad: ({ context }) => {
    if (!context.auth.hasPermission(VIEW_ADMIN_PAGE)) {
      throw notFound();
    }
  },
  component: AdminView,
});
